var priceIncrement = {

    methods: {

        /**
         * Return the price plus incremenr
         *  @param price String
         */

        getPriceWithIncrement: function( price, horasSemanales ) {

            let p = parseInt( price )
            let increment = horasSemanales == 2 ? parseInt( this.getGroupIncrement2 ) : parseInt( this.getGroupIncrement )

            return p + increment

        }

    }

}

export default priceIncrement